module.exports = {
      id: "ic-close-circle-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-close-circle-usage",
      toString: function () {
        return this.url;
      }
    }